<template>
  <div id="app">
    <!-- Header só fora da sala -->
    <!-- <header v-if="!isMeet">
      <h4 class="logo">Telemedicine</h4>
    </header> -->

    <!-- Aqui SEMPRE renderiza a rota -->
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    isMeet () {
      // rota existe sempre após o router ser montado
      return this.$route && this.$route.path.startsWith('/meet')
    }
  }
}
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
}

#app {
  height: 100%;
  background: #030b12;
  color: #fff;
}

/* Header estilo Google Meet */
header {
  height: 56px;
  background: #030b12;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid #333;
}

.logo {
  margin: 0;
  font-weight: 500;
  font-size: 18px;
}
</style>
